import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { MdMoreHoriz } from "react-icons/md";
import { showModal } from "../../features/modal/modalSlice";
import { useDispatch } from "react-redux";
import { setSelectAdminArac } from "../../features/admin2/admin2Slice";
import { FaCheckCircle } from "react-icons/fa";
import { FaWindowClose } from "react-icons/fa";
import { getEgeyurtIletisimItemData } from "../../features/admin/adminSlice";

const Container = styled.div`
  width: 100%;
  margin-block: 5px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;
    cursor: pointer;
    .content {
      width: 100% !important;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      color: ${({ theme }) => theme.mainTextColor} !important;
      .detay {
        position: absolute;
        right: 10px;
        top: 20px;
        cursor: pointer;
        .more {
          color: ${({ theme }) => theme.mainTextColor} !important;
          font-size: 25px;
        }
      }
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 15px;
        text-align: center;
        background-color: transparent;
        height: 40px;

        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            font-size: 20px;
          }
          
        }
      }
    }
  }
`;

const EgeyutIletisimContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();

  const handleOptions = (e) => {
    e.stopPropagation();
    dispatch(getEgeyurtIletisimItemData(data));
  };

  return (
    <Container theme={theme}>
      <div onClick={() => {dispatch(showModal("updateEgeyurtIletisimItem")); dispatch(getEgeyurtIletisimItemData(data)); }} className="container">
        <div className="content">
          {/* <div onClick={(e) => handleOptions(e)} className="detay">
            <MdMoreHoriz className="more" />
          </div> */}
          <div className="row">
            <div className="col">
              {data?.tittle}
            </div>
            <div className="col">
              {data?.phoneNumber ? data?.phoneNumber : "-"}
            </div>
            <div className="col">
              {data?.email}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default EgeyutIletisimContainer;
